import { AxiosResponse } from 'axios';
import { getAxiosSecureInstance } from '../../utilities/AxiosClient';
import { SecurityModel } from '../../models/security/security';

export interface Organization {
  name?: string;
  avatar: string;
  currency?: string;
  id?: string;
  security?: SecurityModel[];
}

export async function getOrganizationsList(): Promise<AxiosResponse> {
  const orgList = getAxiosSecureInstance().get(`/api/organizations`);
  return orgList;
}

export async function getOrganization(organizationId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}`);
}

export async function getOrganizationSecurity(organizationId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/security/organizations/${organizationId}`);
}

export async function postOrganization(formData: FormData): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(`/api/organizations`, formData);
}

export async function updateOrganization(
  organizationId: string | undefined,
  formData: FormData,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().put(`/api/organizations/${organizationId}`, formData);
}
